import { useLocation } from 'react-router-dom'
import Props from './interfaces'
import * as Styled from './styled'

function Header({ onClickBack, onClickClose }: Props) {
  const location = useLocation()
  const pathsWithoutArrowBack = [
    '/erro/internet',
    '/erro/envio-dados',
    '/sucesso',
    '/recuperar-senha-motorista/dificuldade',
    '/placa/sucesso',
    '/cadastrar/sucesso',
    '/recuperar-senha-motorista/sucesso',
    '/sessao/bloqueio/permanente',
    '/sessao/bloqueio/temporario',
  ]
  const pathsWithoutClose = [
    '/erro/internet',
    '/erro/envio-dados',
    '/placa/sucesso',
    '/cadastrar/sucesso',
    '/recuperar-senha-motorista/sucesso',
    '/sessao/bloqueio/permanente',
    '/sessao/bloqueio/temporario',
  ]
  const showArrowBack = !pathsWithoutArrowBack.includes(location.pathname)
  const showClose = !pathsWithoutClose.includes(location.pathname)

  return (
    <Styled.Header role="heading">
      {showArrowBack && <Styled.ArrowBack onClick={onClickBack} />}
      <Styled.Logo />
      {showClose && <Styled.Close onClick={onClickClose} />}
    </Styled.Header>
  )
}

export default Header
